import "./howWorks.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { card } from "../../utils/globalImages";
import { ReactComponent as BIcon1 } from "../../assets/icons/register.svg";
import { ReactComponent as BIcon2 } from "../../assets/icons/unbox.svg";
import { ReactComponent as BIcon3 } from "../../assets/icons/cashback.svg";
import { ReactComponent as Bulb } from "../../assets/icons/bulb.svg";
import TopUpsPayIcon from "../../assets/drawings/topUpPayIcon.png";

const steps = [
  {
    number: "01",
    label: "Register & Top Up Balance",
    title: "Register & Top Up Balance",
    description:
      "Sign up with your email or social media account and easily top up your balance using multiple payment options.",
    image: card.registerTopup,
    imageAlt: "Register & Topup",
    Icon: BIcon1,
  },
  {
    number: "02",
    label: "Unbox Products & Battle Others",
    title: "Unbox Products & Battle Others",
    description:
      "Explore a wide selection of boxes, unbox exciting rewards, and challenge other players for a chance to win big.",
    image: card.productsBattle,
    imageAlt: "Unbox Products & Battle Others",
    Icon: BIcon2,
  },
  {
    number: "03",
    label: "Cashback or Claim Products",
    title: "Cashback or Claim Products",
    description:
      "Sell any unwanted items back to Droppie for instant cash back or have them delivered right to your doorstep.",
    image: card.deposit,
    imageAlt: "Cashback or Claim Products",
    Icon: BIcon3,
  },
];

const HowWorks = () => {
  const isDarkMode = useSelector((state) => state?.theme?.darkMode);
  const [activeStep, setActiveStep] = useState(0);
  const active = steps[activeStep];

  return (
    <section className="hw-section hw-section-parent container">
      {/* Title */}
      <div className="topbrands-header hw-header">
        <div className="how-works-title">
          <Bulb className="how-works-icon" />
          <span> How it Works</span>
        </div>
      </div>

      {/* ── DESKTOP layout ── */}
      <div className="hw-wrapper hw-desktop-only">
        {/* Left — Step Tabs */}
        <div className="hw-tabs">
          {steps.map((step, index) => {
            const { Icon } = step;
            const isActive = activeStep === index;
            return (
              <button
                key={index}
                className={`hw-tab ${isDarkMode ? "dark" : "light"} ${isActive ? "active" : ""}`}
                onClick={() => setActiveStep(index)}
              >
                <div className={`hw-tab-icon ${index === 0 ? "hw-tab-icon--fill" : ""}`}>
                  <Icon
                    style={{
                      width: 32,
                      height: 32,
                      color: isActive
                        ? "#1a1625"
                        : isDarkMode
                        ? "#9590aa"
                        : "#4a4560",
                    }}
                  />
                </div>
                <div className="hw-tab-text">
                  <span className="hw-tab-step">STEP {step.number}</span>
                  <span className="hw-tab-label">{step.label}</span>
                </div>
              </button>
            );
          })}
        </div>

        {/* Outer card */}
        <div className={`hw-outer-card ${isDarkMode ? "dark" : "light"}`}>
          {activeStep === 0 && (
            <img
              src={TopUpsPayIcon}
              alt="Top Up Pay"
              className="hw-topup-pay-icon"
            />
          )}
          <div className="hw-layout">
            <div className="hw-content" key={activeStep}>
              <div className="hw-number-title-row">
                <span className={`hw-big-number ${isDarkMode ? "dark" : "light"}`}>
                  {active.number}
                </span>
                <h2 className={`hw-title ${isDarkMode ? "dark" : "light"}`}>
                  {active.title}
                  <span className="g-4">
                    <p className={`hw-desc ${isDarkMode ? "dark" : "light"}`}>
                      {active.description}
                    </p>
                  </span>
                </h2>
              </div>
            </div>
            <div
              style={activeStep === 1 ? { marginBottom: "30px" } : {}}
              className="hw-image-panel"
            >
              <img
                key={activeStep}
                src={active.image}
                alt={active.imageAlt}
                className="hw-image"
              />
            </div>
          </div>
        </div>
      </div>

      {/* ── MOBILE layout — all steps expanded & stacked ── */}
      <div className="hw-mobile-only">
        {steps.map((step, index) => {
          const { Icon } = step;
          const isActive = activeStep === index;
          return (
            <div key={index} className="hw-mobile-step">
              {/* Tab button */}
              <button
                className={`hw-tab hw-tab-mobile ${isDarkMode ? "dark" : "light"} ${isActive ? "active" : ""}`}
                onClick={() => setActiveStep(index)}
              >
                <div className={`hw-tab-icon ${index === 0 ? "hw-tab-icon--fill" : ""}`}>
                  <Icon
                    style={{
                      width: 28,
                      height: 28,
                      color: isActive
                        ? "#1a1625"
                        : isDarkMode
                        ? "#9590aa"
                        : "#4a4560",
                    }}
                  />
                </div>
                <div className="hw-tab-text">
                  <span className="hw-tab-step">STEP {step.number}</span>
                  <span className="hw-tab-label">{step.label}</span>
                </div>
              </button>

              {/* Step content card — always visible on mobile */}
              <div className={`hw-mobile-card ${isDarkMode ? "dark" : "light"}`}>
                {index === 0 && (
                  <img
                    src={TopUpsPayIcon}
                    alt="Top Up Pay"
                    className="hw-topup-pay-icon hw-topup-pay-icon--mobile"
                  />
                )}
                <div className="hw-mobile-layout">
                  {/* Content */}
                  <div className="hw-content hw-mobile-content">
                    <div className="hw-number-title-row">
                      <span className={`hw-big-number ${isDarkMode ? "dark" : "light"}`}>
                        {step.number}
                      </span>
                      <h2 className={`hw-title ${isDarkMode ? "dark" : "light"}`}>
                        {step.title}
                        <span className="g-4">
                          <p className={`hw-desc ${isDarkMode ? "dark" : "light"}`}>
                            {step.description}
                          </p>
                        </span>
                      </h2>
                    </div>
                  </div>

                  {/* Image */}
                  <div className="hw-mobile-image-panel">
                    <img
                      src={step.image}
                      alt={step.imageAlt}
                      className="hw-image hw-mobile-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HowWorks;